import React from "react";
import { InputJson } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import NavBar from "../../../../components/NavBar";
import FormFactory from "../../../../components/FormFactory";
import withRouter from "../../../../withRouter";
import NoticeTemplateFormPresenter from "./NoticeTemplateFormPresenter";
import RichText from "../../../../components/common/RichText";

class NoticeTemplateFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false, description: "" };
    this.presenter = new NoticeTemplateFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      this.setState({ description: this.state.object.description });
    }
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }
  getCollectionName() {
    return "notice_templates";
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    console.log("OBJECT: ", object);
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Update ";
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    // this.presenter.handleSubmitUser();
                    this.presenter.save();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <FormFactory
                          schema={schema}
                          object={object}
                          // disabled={true}
                          onChange={this.onChange.bind(this)}
                          excludeFields={["description"]}
                        />
                        <RichText
                          onContentChange={(value) =>
                            this.onChange(value, "description")
                          }
                          disabled={this.props.action === "view"}
                          content={this.state.description}
                        />
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(NoticeTemplateFormPage);
